import forge from "node-forge";

export class EncryptionService {
  private publicKey: forge.pki.PublicKey | null = null;

  async loadPublicKey(): Promise<void> {
    try {
      const response = await fetch("/icegems-public-key.pem");
      const pem = await response.text();
      this.publicKey = forge.pki.publicKeyFromPem(pem) as forge.pki.rsa.PublicKey;
    } catch (err) {
      console.error("Failed to load public key:", err);
      throw err;
    }
  }

  encryptField(value: string): string {
    if (!this.publicKey) {
      throw new Error("Public key not loaded");
    }

    const encrypted = (this.publicKey as forge.pki.rsa.PublicKey).encrypt(
      forge.util.encodeUtf8(value),
      "RSAES-PKCS1-V1_5"
    );
    return forge.util.encode64(encrypted);
  }

  getPublicKey(): forge.pki.PublicKey | null {
    return this.publicKey;
  }
} 